import React from 'react';

// Bold is also supported through the className prop

const Typography = props => {
	const { type, className, children } = props;
	const Tag = type === 'heading-label' ? 'div' : type;

	return (
		<Tag className={`typography ${type} ${className || ''}`}>{children}</Tag>
	);
};

Typography.H1 = props => <Typography {...props} type="h1" />;
Typography.H2 = props => <Typography {...props} type="h2" />;
Typography.H3 = props => <Typography {...props} type="h3" />;
Typography.H4 = props => <Typography {...props} type="h4" />;
Typography.P = props => <Typography {...props} type="p" />;
Typography.HeadingLabel = props => (
	<Typography {...props} type="heading-label" />
);

export default Typography;
